import { useTranslation } from 'react-i18next';
import { Field } from 'formik';

import {
    HEADER_IMAGE_MAX_SIZE,
    HEADER_IMAGE_TYPE,
} from 'common/constants/files';
import { IMAGE_VARIANTS } from 'common/constants/image';
import { EImageVariant } from 'common/types';
import { ImageField } from 'common/components/FormField';

export const LibraryHeaderImageField = () => {
    const [translate] = useTranslation();

    return (
        <Field
            withDefaults
            acceptedFileTypes={HEADER_IMAGE_TYPE}
            component={ImageField}
            helperText={translate('imageSizeDescription', {
                width: IMAGE_VARIANTS[EImageVariant.Header].minWidth,
                height: IMAGE_VARIANTS[EImageVariant.Header].minHeight,
            })}
            imageVariant={EImageVariant.Header}
            label={translate('headerImage')}
            maxUploadSize={HEADER_IMAGE_MAX_SIZE}
            name="headerImage"
        />
    );
};
